<div class="modal-header d-flex align-items-center justify-content-center position-relative">
    <div><span class="font-semibold text-primary">{{data?.Title}}</span></div>
    <app-svg-icon [name]="'cross_button_border'" class="cross-button-border"></app-svg-icon>
    <app-svg-icon [name]="'cross'" class="cross-button" [ngClass]="currentHoverEffect" (click)="activeModal.close()"></app-svg-icon>
</div>
<app-accountledger-report (emitFilterData)="intializeAccountledgerId()" [data]="data" ></app-accountledger-report>